import RowsCache from "../jslibs/RowsCache"
import { ISelectRow } from "../libs/dropdown/Dropdown";
import { type IFood } from "../shared/IFood";
import FoodApi from "./FoodApi";

export default class Foods extends RowsCache<IFood> {
    private static _i:Foods
    private _options!:ISelectRow<number>[]
    
    static get i(){
        if (!this._i) this._i = (window as any).foods = new Foods("foods", 0)
        return this._i
    }
    fetch(): Promise<IFood[]> {
        return FoodApi.i.foods().then(all => all.sort((l,r) => l.name.localeCompare(r.name)))
    }
    key(row: IFood): string {
        return row._id.toString()
    }
    get options(){return this._options}
    id2option(id:number) { return this._options.find(o => o.value==id) || null}
    protected onCache(cache:IFood[]){
        super.onCache(cache)
        this._options = cache.map(food=>({value:food._id,label:food.name}))
    }
    name(id:number){
        return this.fromCache(id.toString())?.name || id.toString()
    }

}
